import { api } from "./client";

const API_BASE_URL = process.env.REACT_APP_API_BASE_URL;

export const getProductQuantityReport = async (params = {}) => {
  try {
    const lang = localStorage.getItem("lang") || "en";

    const response = await api.get(
      `${API_BASE_URL}api/product-quantity-report/list`,
      {
        params,
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${localStorage.getItem("token")}`,
          "Accept-Language": lang,
        },
      }
    );

    return response.data;
  } catch (error) {
    console.error("Get Product Quantity Report API Error:", error);
    throw error.response?.data || {
      message: "Failed to fetch product quantity report",
    };
  }
};

export const getProductQuantityReportFilters = async () => {
  try {
    const lang = localStorage.getItem("lang") || "en";

    const response = await api.get(
      `${API_BASE_URL}api/product-quantity-report/filters`,
      {
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${localStorage.getItem("token")}`,
          "Accept-Language": lang,
        },
      }
    );

    return response.data;
  } catch (error) {
    console.error("Get Product Quantity Report Filters API Error:", error);
    throw error.response?.data || {
      message: "Failed to fetch product quantity report filters",
    };
  }
};

export const exportProductQuantityReportExcel = async (params = {}) => {
  try {
    const lang = localStorage.getItem("lang") || "en";

    const response = await api.get(
      `${API_BASE_URL}api/product-quantity-report/export/excel`,
      {
        params,
        responseType: "blob",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${localStorage.getItem("token")}`,
          "Accept-Language": lang,
        },
      }
    );

    return response.data;
  } catch (error) {
    console.error("Export Product Quantity Report Excel API Error:", error);
    throw error.response?.data || {
      message: "Failed to export quantity report excel",
    };
  }
};

export const exportProductQuantityReportPdf = async (params = {}) => {
  try {
    const lang = localStorage.getItem("lang") || "en";

    const response = await api.get(
      `${API_BASE_URL}api/product-quantity-report/export/pdf`,
      {
        params,
        responseType: "blob",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${localStorage.getItem("token")}`,
          "Accept-Language": lang,
        },
      }
    );

    return response.data;
  } catch (error) {
    console.error("Export Product Quantity Report PDF API Error:", error);
    throw error.response?.data || {
      message: "Failed to export quantity report pdf",
    };
  }
};